import { Injectable, Injector } from '@angular/core';
import { HubSdkBase } from '../utilities/hub-sdk-base/hub-sdk.base';
import { map, Observable, shareReplay } from 'rxjs';
import { QueuedStepsRowResource } from '@models/resource/queued-steps-row.resource';
import { QueuedStepsRowResourceToProcessingStepsRowMapper } from '@models/mappers/queued-steps-row-resource-to-processing-steps-row.mapper';
import { ProcessingStepsRow } from '@models/ui/queued-steps-row.model';
import { ActiveProcessingStepHistogramToProcessingStepsRowMapper } from '@models/mappers/active-processing-step-histogram-to-processing-steps-row.mapper';
import { ActiveProcessingStepHistogram } from '@models/resource/active-processing-histogram.resource';
import { Case } from '@models/ui/case.model';
import { CaseWithDocCountResource } from '@models/resource/case-with-doc-count.resource';
import { CaseWithDocCountResourceToCaseMapper } from '@models/mappers/case-with-doc-count-resource-to-case.mapper';
import { Server } from '@models/ui/server.model';
import { ServerResource } from '@models/resource/server.resource';
import { MicroserviceHostRuntimeInformationResource } from '@models/resource/microservice-host-runtime-information.resource';
import { WorkflowStateResource } from "@models/resource/workflow-state.resource";

@Injectable({
	providedIn: 'root'
})
export class ProcessingHubSdk extends HubSdkBase {
	constructor(injector: Injector) {
		super(injector, 'processing');
	}

	public activeSteps$: Observable<ProcessingStepsRow[]> =
		this.on$<ActiveProcessingStepHistogram[]>('activeSteps').pipe(
			map((response) => {
				const mapper = new ActiveProcessingStepHistogramToProcessingStepsRowMapper();
				return mapper.mapCollection(response);
			}),
			shareReplay({ bufferSize: 1, refCount: true })
		);

	public indexDocCountOutOfSync$: Observable<Case[]> =
		this.on$<CaseWithDocCountResource[]>('activeCasesWithIndexDocCountOutOfSync').pipe(
			map((response) => {
				const mapper = new CaseWithDocCountResourceToCaseMapper();
				return mapper.mapCollection(response);
			}),
			shareReplay({ bufferSize: 1, refCount: true })
		);

	public kbDocCountOutOfSync$: Observable<Case[]> =
		this.on$<CaseWithDocCountResource[]>('activeCasesWithKBDocCountOutOfSync').pipe(
			map((response) => {
				const mapper = new CaseWithDocCountResourceToCaseMapper();
				return mapper.mapCollection(response);
			}),
			shareReplay({ bufferSize: 1, refCount: true })
		);

	public allSteps$: Observable<ProcessingStepsRow[]> =
		this.on$<QueuedStepsRowResource[]>('allSteps').pipe(
			map((response) => {
				const mapper = new QueuedStepsRowResourceToProcessingStepsRowMapper();
				return mapper.mapCollection(response);
			}),
			shareReplay({ bufferSize: 1, refCount: true })
		);

	public servers$: Observable<Server[]> =
		this.on$<ServerResource[]>('servers').pipe(
			map((response) => {
				return response?.map((server) => new Server(server));
			}),
			shareReplay({ bufferSize: 1, refCount: true })
		);

	public microservicesSummary$: Observable<MicroserviceHostRuntimeInformationResource[]> =
		this.on$<any[]>('runningMicroserviceHostsSummary').pipe(
			shareReplay({ bufferSize: 1, refCount: true })
		);

	public workflows$: Observable<WorkflowStateResource[]> =
		this.on$<WorkflowStateResource[]>('activeWorkflows').pipe(
			shareReplay({ bufferSize: 1, refCount: true })
		);

}
